let initialState = {
  item: null
};

const tos = (state = initialState, action) => {
  switch(action.type) {
    case 'STORE_TOS':
      return {
        ...state,
        item: action.payload
      }

    case 'CLEAR_TOS':
      return {
        ...state,
        item: initialState.item
      }

    default:
      return state
  }
}

export default tos;



// WEBPACK FOOTER //
// ./src/reducers/tos.js